/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-18 10:36:14
 */
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { getBreakageAsync } from './disqualificationBreakageManagementSlice'
import { unwrapResult } from '@reduxjs/toolkit'

const { Option } = Select

export const BreakageReasonModal = (props: {
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
  }

  useEffect(() => {
    if (!props.isModalVisible) {
      form.resetFields()
    }
  }, [props.isModalVisible])

  return (
    <Modal
      width={600}
      title={'过期报损原因'}
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <Form
        form={form}
        onFinish={(vs) => {
          setConfirmLoading(true)
          dispatch(getBreakageAsync(vs?.reason))
            .then(unwrapResult)
            .then((v: any) => {
              if (v == 0) {
                notification.info({
                  message: '商品已全部报损，无需再次报损',
                })
              } else {
                notification.success({
                  message: '操作成功',
                })
              }
              props?.onOk()
            })
            .catch(() => {
              props?.onCancel()
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
      >
        <Row>
          <Col span={24}>
            <Form.Item {...layout} label='报损原因' name='reason'>
              <Input.TextArea
                placeholder='报损原因'
                maxLength={300}
                showCount
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            loading={confirmLoading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
            style={{ marginRight: '10px' }}
          >
            确定
          </Button>
          <Button
            type='primary'
            ghost
            style={{ marginRight: '10px' }}
            onClick={() => {
              props?.onCancel()
            }}
          >
            取消
          </Button>
        </Row>
      </Form>
    </Modal>
  )
}
